<template>
  <!--编辑成品附加费-->
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading='loading' type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      data: {
        incidental: '', // 杂费
        profit: '' // 利润
      },
      options: [
        {
          name: 'incidental',
          note: '杂费',
          type: 'Number',
          validators: [
            (val) => val ? null : '杂费不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的价格'
              }
            }
          ]
        },
        {
          name: 'profit',
          note: '利润',
          type: 'Number',
          validators: [
            (val) => val ? null : '利润不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的价格'
              }
            }
          ]
        }
      ]
    }
  },
  async mounted () {
    if (this.record) {
      if (this.record.incidental) { this.data.incidental = this.record.incidental }
      if (this.record.profit) { this.data.profit = this.record.profit }
    } else {
      let d = {
        type: this.classify,
        proportion: this.proportion,
        model: this.modelId,
        workShop: this.workShop
      }
      this.data = { ...this.data, ...d }
    }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    },
    async submit () {
      // 验证必填项
      let erros = await this.$refs.input.validate()
      if (Object.keys(erros).length) return
      this.loading = !this.loading
      if (this.record) {
        await this.$modelAjax.put('surcharge', this.record.objectId, this.data).catch(e => {
          throw this.$notification['error']({
            message: '保存失败',
            description: '保存失败，请重新尝试'
          })
        })
      } else {
        // 新建, 判断此含量下是否已有同分类附加费
        let res = await this.$modelAjax.getData('surcharge', {
          params: {
            where: {
              type: this.classify,
              proportion: this.proportion
            }
          }
        })
        if (res.results.length) {
          this.loading = !this.loading
          throw this.$notification['error']({
            message: '保存失败',
            description: '此型号含量已有附加费'
          })
        } else {
          await this.$modelAjax.post('surcharge', this.data).catch(e => {
            this.loading = !this.loading
            throw this.$notification['error']({
              message: '保存失败',
              description: '保存失败，请重新尝试'
            })
          })
        }
      }
      this.$notification['success']({
        message: '保存成功',
        description: '数据已保存'
      })
      this.vm.refresh()
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    vm: null,
    title: String,
    classify: String,
    proportion: null,
    modelId: null,
    workShop: null,
    record: Object
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .ant-form-item-label > label::after {
    content: none !important;
  }
</style>
